import { Clock, CheckCircle2, XCircle, AlertCircle } from "lucide-react";

export function formatCurrency(value) {
  return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(value || 0);
}

export function formatDate(dateStr) {
  if (!dateStr) return "-";
  return new Date(dateStr + "T00:00:00").toLocaleDateString('pt-BR');
}

export const statusConfig = {
  pendente: { label: "Pendente", class: "bg-amber-100 text-amber-700", icon: Clock },
  pago: { label: "Pago", class: "bg-green-100 text-green-700", icon: CheckCircle2 },
  cancelado: { label: "Cancelado", class: "bg-red-100 text-red-700", icon: XCircle },
  vencido: { label: "Vencido", class: "bg-red-100 text-red-700", icon: AlertCircle }
};
